import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import { NotificationsNoneOutlined } from '@material-ui/icons'
import { Badge } from '@material-ui/core'

const NewsButton = (props) => {
    const { handleClick, unreadNews } = props

    return (
        <IconButton
            onClick={handleClick}
            color="inherit"
        >
            <Badge 
                badgeContent={unreadNews.length} 
                color='error'
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <NotificationsNoneOutlined />
            </Badge>
        </IconButton>
  )
}

export default NewsButton
